import React, { memo, useEffect, useRef, useState } from "react"
import { Box } from "@mos-cat/ds"
import styles from "../toolbarPlugin.module.css"

import { useSize } from "ahooks"
import { ActionsPopover } from "@dit/core-frontend"

export const ToolbarContainer = memo(({ children, editorRef }) => {
  const containerRef = useRef(null)
  const mainButtonsRef = useRef(null)
  const [visibleChildren, setVisibleChildren] = useState([])
  const [hiddenChildren, setHiddenChildren] = useState([])

  const containerSize = useSize(containerRef)
  useEffect(() => {
    if (containerSize && children.length) {
      let width = 0
      const visible = []
      const hidden = []
      children.map((child) => {
        if (width < containerSize.width - 90) {
          width = width + (child?.ref?.current?.offsetWidth || 20)
          visible.push(child)
        } else {
          //добавляем только управляющие кнопки. без разделителей
          child?.type !== "div" && !child?.props["aria-hidden"] && hidden.push(child)
        }
        return undefined
      })
      setVisibleChildren(visible)
      setHiddenChildren(hidden)
      width = 0
    }
  }, [children, containerSize])

  return (
    <Box className={styles.toolbarItems} ref={containerRef}>
      <Box display="none" alignItems="center">
        {children}
      </Box>
      <Box display="flex" alignItems="center" ref={mainButtonsRef}>
        {visibleChildren}
      </Box>
      {!!hiddenChildren.length && (
        <Box>
          <ActionsPopover portalContainer={editorRef.current}>
            {() => (
              <Box display="flex" alignItems="center" gridGap="10px" flexWrap="wrap">
                {hiddenChildren}
              </Box>
            )}
          </ActionsPopover>
        </Box>
      )}
    </Box>
  )
})

ToolbarContainer.displayName = "ToolbarContainerComp"
